import React from 'react';
import { Select } from 'antd';
import { HTTP_STATUS_OK } from 'constants/config';
import { fetchStoreList } from 'services/storeSetup';

type Props = {
  onChange?: Function;
};

const StoreSelector = (props: Props) => {
  const { useState } = React;
  const [inited, setInited] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMounted, setIsMounted] = useState<boolean>();
  const [options, setOptions] = useState<StringKAnyVPair[]>([]);

  // eslint-disable-next-line
  const getStoreOptions = async () => {
    if (isMounted) setIsLoading(true);
    try {
      const { code, data } = await fetchStoreList();

      if (code === HTTP_STATUS_OK && Array.isArray(data)) {
        //console.log('d', data);
        setOptions(data.map(e => ({
          //...e,
          channelAccountNum: e.channelAccountNum,
          label: e.channelAccountName,
          value: e.channelAccountNum,
        })));
      }
    } catch(e) {
    } finally {
      if (isMounted) setIsLoading(false);
    }
  };

  const onChange = (val: any) => {
    const opt = options.find(e => e.value === val);
    //console.log('ch', opt);
    props.onChange && props.onChange(opt);
  };

  React.useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  React.useEffect(() => {
    if (isMounted && !inited) {
      getStoreOptions();
      setInited(true);
    }
  }, [getStoreOptions, inited, isMounted]);

  return (<>
    <Select
      loading={isLoading}
      onChange={onChange}
      optionFilterProp="label"
      options={options}
      showSearch
    />
  </>);
};

export default StoreSelector;
